/* THUNDER HONEY V3, Shopify theme only. Never ported, edit it here. Loaded (defer) by snippets/th-v3-head.

   Newsletter sign-up events, the Shopify side of what _deploy_baseline/_v3/track.js does on thunderhoney.co.
   th-v3-base.js sends the footer form to Klaviyo and hides the form only once Klaviyo accepted it, so a form that turns
   hidden is a real sign-up. Then:
   - Shopify.analytics.publish('th_newsletter_signup', ...) always. A custom pixel (Settings > Customer events) can
     subscribe to it and forward it; Shopify applies the visitor's consent to that pixel. The Meta and Google channel
     apps do not read custom events by themselves.
   - fbq('track', 'Lead') and gtag('event', 'generate_lead') only when those functions exist on the page and the
     visitor allowed marketing (Meta) or analytics (Google) through Shopify's Customer Privacy API.
   No email address or other personal data goes into any of these events. */
(function () {
  'use strict';
  var d = document, w = window;
  if (!('MutationObserver' in w)) return;

  function allowed(fn) {
    try { var cp = w.Shopify && w.Shopify.customerPrivacy; return !!(cp && typeof cp[fn] === 'function' && cp[fn]()); } catch (e) { return false; }
  }

  function signedUp(form) {
    var where = form.closest('footer') ? 'footer' : ((form.closest('section') && form.closest('section').id) || 'page');
    try {
      if (w.Shopify && w.Shopify.analytics && typeof w.Shopify.analytics.publish === 'function') {
        w.Shopify.analytics.publish('th_newsletter_signup', { lead_source: 'newsletter', form_location: where, list_id: 'VdukM9', page: location.pathname });
      }
    } catch (e) {}
    if (typeof w.fbq === 'function' && allowed('marketingAllowed')) {
      try { w.fbq('track', 'Lead', { content_name: 'Newsletter', content_category: 'newsletter' }); } catch (e) {}
    }
    if (typeof w.gtag === 'function' && allowed('analyticsProcessingAllowed')) {
      try { w.gtag('event', 'generate_lead', { lead_source: 'newsletter', form_location: where }); } catch (e) {}
    }
    try { d.dispatchEvent(new CustomEvent('th:newsletter', { detail: { form_location: where } })); } catch (e) {}
  }

  [].forEach.call(d.querySelectorAll('form[data-news]'), function (form) {
    new MutationObserver(function () {
      if (!form.hidden || form.__thLead) return;
      form.__thLead = 1;
      signedUp(form);
    }).observe(form, { attributes: true, attributeFilter: ['hidden'] });
  });
})();
